export default "__VITE_ASSET__4lcMVMy4__"